import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { isRouteErrorResponse, useRouteError } from "react-router-dom";

const AUTO_RELOAD_SECONDS = 5;

export const ErrorPage = () => {
  const { t } = useTranslation("general", { keyPrefix: "general.error" });
  const error = useRouteError();
  const [isReloading, setIsReloading] = useState(false);
  const [countdown, setCountdown] = useState(AUTO_RELOAD_SECONDS);

  // 針對動態 import 錯誤立即 reload
  useEffect(() => {
    if (isRouteErrorResponse(error)) {
      if (!(error instanceof Error)) return;
      if (
        error.message.includes("Failed to fetch dynamically imported module") ||
        error.message.includes("Importing a module script failed")
      ) {
        console.log("Import error");
        setIsReloading(true);
        window.location.reload();
      }
    }
  }, [error]);

  // 自動 reload 倒數
  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          setIsReloading(true);
          window.location.reload();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  const handleReloadNow = () => {
    setIsReloading(true);
    window.location.reload();
  };

  return (
    <div className="flex flex-col items-center justify-center h-screen gap-4">
      {isReloading && (
        <div className="fixed inset-0 flex items-center justify-center bg-black/50 z-50">
          <div className="flex flex-col items-center gap-4 text-white">
            <div className="w-10 h-10 border-4 border-white border-t-transparent rounded-full animate-spin" />
            <span className="text-lg">
              {(t as (k: string) => string)("reloading")}
            </span>
          </div>
        </div>
      )}
      <div className="text-[64px]">{t("oops")}</div>
      <div className="text-[32px]">
        {t("errorOccurred")} <br />
        {t("reloadOrContact")}
      </div>
      <div className="text-[24px]">
        <i>
          Error:{" "}
          {(error as Error)?.message ||
            (error as { statusText?: string })?.statusText}
        </i>
      </div>
      <div className="flex flex-col items-center gap-2 mt-4">
        <p className="text-[18px] text-gray-600">
          {countdown > 0
            ? (t as (k: string, o: { count?: number }) => string)(
                "autoReloadIn",
                { count: countdown },
              )
            : (t as (k: string) => string)("reloading")}
        </p>
        <button
          type="button"
          onClick={handleReloadNow}
          disabled={isReloading}
          className="px-4 py-2 bg-gray-800 text-white rounded-lg hover:bg-gray-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
        >
          {(t as (k: string) => string)("reloadNow")}
        </button>
      </div>
    </div>
  );
};
